export const COUNTRIES = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Åland Islands', code: 'AX' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  // { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia (Plurinational State of)', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Brunei Darussalam', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Cabo Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Congo (the Democratic Republic of the)', code: 'CD' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: "Côte d'Ivoire", code: 'CI' },
  { name: 'Croatia', code: 'HR' },
  // { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czechia', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Heard Island and McDonald Islands', code: 'HM' },
  { name: 'Holy See', code: 'VA' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  // { name: 'Iran (Islamic Republic Of)', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  // { name: "Korea, Democratic People'S Republic", code: 'KP' },
  { name: 'Korea (the Republic of)', code: 'KR' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: "Lao People's Democratic Republic", code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macao', code: 'MO' },
  { name: 'North Macedonia', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia (Federated States of)', code: 'FM' },
  { name: 'Moldova (the Republic of)', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Netherlands Antilles (Deprecated)', code: 'AN' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestine, State of', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Pitcairn', code: 'PN' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Réunion', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  // { name: 'Russian Federation', code: 'RU' },
  { name: 'Rwanda', code: 'RW' },
  { name: 'Saint Helena, Ascension and Tristan da Cunha', code: 'SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia and Montenegro (Deprecated)', code: 'CS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Eswatini', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  // { name: 'Syrian Arab Republic', code: 'SY' },
  { name: 'Taiwan (Province of China)', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania, the United Republic of', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Türkiye', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'US Minor Outlying Islands', code: 'UM' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  // { name: 'Venezuela', code: 'VE' },
  { name: 'Viet Nam', code: 'VN' },
  { name: 'Virgin Islands (British)', code: 'VG' },
  { name: 'Virgin Islands (U.S.)', code: 'VI' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' },
];

export const US_STATES = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'GU',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VI',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
  'AE',
  'AP',
];

export enum COUNTRY_NAMES {
  AFGHANISTAN = 'Afghanistan',
  ALAND_ISLANDS = 'Aland Islands',
  ALBANIA = 'Albania',
  ALGERIA = 'Algeria',
  AMERICAN_SAMOA = 'American Samoa',
  ANDORRA = 'Andorra',
  ANGOLA = 'Angola',
  ANGUILLA = 'Anguilla',
  ANTARCTICA = 'Antarctica',
  ANTIGUA_AND_BARBUDA = 'Antigua and Barbuda',
  ARGENTINA = 'Argentina',
  ARMENIA = 'Armenia',
  ARUBA = 'Aruba',
  AUSTRALIA = 'Australia',
  AUSTRIA = 'Austria',
  AZERBAIJAN = 'Azerbaijan',
  BAHAMAS = 'Bahamas',
  BAHRAIN = 'Bahrain',
  BANGLADESH = 'Bangladesh',
  BARBADOS = 'Barbados',
  BELARUS = 'Belarus',
  BELGIUM = 'Belgium',
  BELIZE = 'Belize',
  BENIN = 'Benin',
  BERMUDA = 'Bermuda',
  BHUTAN = 'Bhutan',
  BOLIVIA = 'Bolivia',
  BONAIRE_SAINT_EUSTATIUS_AND_SABA = 'Bonaire, Saint Eustatius and Saba',
  BOSNIA_AND_HERZEGOVINA = 'Bosnia and Herzegovina',
  BOTSWANA = 'Botswana',
  BOUVET_ISLAND = 'Bouvet Island',
  BRAZIL = 'Brazil',
  BRITISH_INDIAN_OCEAN_TERRITORY = 'British Indian Ocean Territory',
  BRUNEI_DARUSSALAM = 'Brunei Darussalam',
  BULGARIA = 'Bulgaria',
  BURKINA_FASO = 'Burkina Faso',
  BURUNDI = 'Burundi',
  CAMBODIA = 'Cambodia',
  CAMEROON = 'Cameroon',
  CANADA = 'Canada',
  CANARY_ISLANDS = 'Canary Islands',
  CAPE_VERDE = 'Cape Verde',
  CAYMAN_ISLANDS = 'Cayman Islands',
  CENTRAL_AFRICAN_REPUBLIC = 'Central African Republic',
  CEUTA_AND_MELILLA = 'Ceuta and Melilla',
  CHAD = 'Chad',
  CHILE = 'Chile',
  CHINA = 'China',
  CHRISTMAS_ISLAND = 'Christmas Island',
  COCOS_ISLANDS = 'Cocos (Keeling) Islands',
  COLOMBIA = 'Colombia',
  COMOROS = 'Comoros',
  DEMOCRATIC_REPUBLIC_OF_CONGO = 'Congo, Democratic Republic of',
  REPUBLIC_OF_CONGO = 'Congo, Republic of',
  COOK_ISLANDS = 'Cook Islands',
  COSTA_RICA = 'Costa Rica',
  COTE_DIVOIRE = "Cote d'Ivoire",
  CROATIA = 'Croatia',
  CUBA = 'Cuba',
  CURAÇAO = 'Curaçao',
  CYPRUS = 'Cyprus',
  CZECH_REPUBLIC = 'Czech Republic',
  DENMARK = 'Denmark',
  DJIBOUTI = 'Djibouti',
  DOMINICA = 'Dominica',
  DOMINICAN_REPUBLIC = 'Dominican Republic',
  EAST_TIMOR = 'East Timor',
  ECUADOR = 'Ecuador',
  EGYPT = 'Egypt',
  EL_SALVADOR = 'El Salvador',
  EQUATORIAL_GUINEA = 'Equatorial Guinea',
  ERITREA = 'Eritrea',
  ESTONIA = 'Estonia',
  ETHIOPIA = 'Ethiopia',
  FALKLAND_ISLANDS = 'Falkland Islands',
  FAROE_ISLANDS = 'Faroe Islands',
  FIJI = 'Fiji',
  FINLAND = 'Finland',
  FRANCE = 'France',
  FRENCH_GUIANA = 'French Guiana',
  FRENCH_POLYNESIA = 'French Polynesia',
  FRENCH_SOUTHERN_TERRITORIES = 'French Southern Territories',
  GABON = 'Gabon',
  GAMBIA = 'Gambia',
  GEORGIA = 'Georgia',
  GERMANY = 'Germany',
  GHANA = 'Ghana',
  GIBRALTAR = 'Gibraltar',
  GREECE = 'Greece',
  GREENLAND = 'Greenland',
  GRENADA = 'Grenada',
  GUADELOUPE = 'Guadeloupe',
  GUAM = 'Guam',
  GUATEMALA = 'Guatemala',
  GUERNSEY = 'Guernsey',
  GUINEA = 'Guinea',
  GUINEA_BISSAU = 'Guinea-Bissau',
  GUYANA = 'Guyana',
  HAITI = 'Haiti',
  HEARD_AND_MCDONALD_ISLANDS = 'Heard and McDonald Islands',
  VATICAN = 'Holy See (City Vatican State)',
  HONDURAS = 'Honduras',
  HONG_KONG = 'Hong Kong',
  HUNGARY = 'Hungary',
  ICELAND = 'Iceland',
  INDIA = 'India',
  INDONESIA = 'Indonesia',
  IRAN = 'Iran (Islamic Republic of)',
  IRAQ = 'Iraq',
  IRELAND = 'Ireland',
  ISLE_OF_MAN = 'Isle of Man',
  ISRAEL = 'Israel',
  ITALY = 'Italy',
  JAMAICA = 'Jamaica',
  JAPAN = 'Japan',
  JERSEY = 'Jersey',
  JORDAN = 'Jordan',
  KAZAKHSTAN = 'Kazakhstan',
  KENYA = 'Kenya',
  KIRIBATI = 'Kiribati',
  DEMOCRATIC_REPUBLIC_KOREA = "Korea, Democratic People's Republic",
  REPUBLIC_OF_KOREA = 'Korea, Republic of',
  KOSOVO = 'Kosovo',
  KUWAIT = 'Kuwait',
  KYRGYZSTAN = 'Kyrgyzstan',
  LAO_PEOPLE_DEMOCRATIC_REPUBLIC = "Lao People's Democratic Republic",
  LATVIA = 'Latvia',
  LEBANON = 'Lebanon',
  LESOTHO = 'Lesotho',
  LIBERIA = 'Liberia',
  LIBYA = 'Libya',
  LIECHTENSTEIN = 'Liechtenstein',
  LITHUANIA = 'Lithuania',
  LUXEMBOURG = 'Luxembourg',
  MACAU = 'Macau',
  MACEDONIA = 'Macedonia',
  MADAGASCAR = 'Madagascar',
  MALAWI = 'Malawi',
  MALAYSIA = 'Malaysia',
  MALDIVES = 'Maldives',
  MALI = 'Mali',
  MALTA = 'Malta',
  MARSHALL_ISLANDS = 'Marshall Islands',
  MARTINIQUE = 'Martinique',
  MAURITANIA = 'Mauritania',
  MAURITIUS = 'Mauritius',
  MAYOTTE = 'Mayotte',
  MEXICO = 'Mexico',
  FEDERAL_STATE_OF_MICRONESIA = 'Micronesia, Federal State of',
  REPUBLIC_OF_MOLDOVA = 'Moldova, Republic of',
  MONACO = 'Monaco',
  MONGOLIA = 'Mongolia',
  MONTENEGRO = 'Montenegro',
  MONTSERRAT = 'Montserrat',
  MOROCCO = 'Morocco',
  MOZAMBIQUE = 'Mozambique',
  MYANMAR = 'Myanmar (Burma)',
  NAMIBIA = 'Namibia',
  NAURU = 'Nauru',
  NEPAL = 'Nepal',
  NETHERLANDS = 'Netherlands',
  NETHERLANDS_ANTILLES = 'Netherlands Antilles (Deprecated)',
  NEW_CALEDONIA = 'New Caledonia',
  NEW_ZEALAND = 'New Zealand',
  NICARAGUA = 'Nicaragua',
  NIGER = 'Niger',
  NIGERIA = 'Nigeria',
  NIUE = 'Niue',
  NORFOLK_ISLAND = 'Norfolk Island',
  NORTHERN_MARIANA_ISLANDS = 'Northern Mariana Islands',
  NORWAY = 'Norway',
  OMAN = 'Oman',
  PAKISTAN = 'Pakistan',
  PALAU = 'Palau',
  PANAMA = 'Panama',
  PAPUA_NEW_GUINEA = 'Papua New Guinea',
  PARAGUAY = 'Paraguay',
  PERU = 'Peru',
  PHILIPPINES = 'Philippines',
  PITCAIRN_ISLAND = 'Pitcairn Island',
  POLAND = 'Poland',
  PORTUGAL = 'Portugal',
  PUERTO_RICO = 'Puerto Rico',
  QATAR = 'Qatar',
  REUNION_ISLAND = 'Reunion Island',
  ROMANIA = 'Romania',
  RUSSIAN_FEDERATION = 'Russian Federation',
  RWANDA = 'Rwanda',
  SAINT_BARTHÉLEMY = 'Saint Barthélemy',
  SAINT_HELENA = 'Saint Helena',
  SAINT_KITTS_AND_NEVIS = 'Saint Kitts And Nevis',
  SAINT_LUCIA = 'Saint Lucia',
  SAINT_MARTIN = 'Saint Martin',
  SAINT_VINCENT_AND_THE_GRENADINES = 'Saint Vincent and the Grenadines',
  SAMOA = 'Samoa',
  SAN_MARINO = 'San Marino',
  SAO_TOME_AND_PRINCIPE = 'Sao Tome and Principe',
  SAUDI_ARABIA = 'Saudi Arabia',
  SENEGAL = 'Senegal',
  SERBIA = 'Serbia',
  SERBIA_AND_MONTENEGRO = 'Serbia and Montenegro (Deprecated)',
  SEYCHELLES = 'Seychelles',
  SIERRA_LEONE = 'Sierra Leone',
  SINGAPORE = 'Singapore',
  SINT_MAARTEN = 'Sint Maarten',
  SLOVAK_REPUBLIC = 'Slovak Republic',
  SLOVENIA = 'Slovenia',
  SOLOMON_ISLANDS = 'Solomon Islands',
  SOMALIA = 'Somalia',
  SOUTH_AFRICA = 'South Africa',
  SOUTH_GEORGIA = 'South Georgia',
  SOUTH_SUDAN = 'South Sudan',
  SPAIN = 'Spain',
  SRI_LANKA = 'Sri Lanka',
  ST_PIERRE_AND_MIQUELON = 'St. Pierre and Miquelon',
  STATE_OF_PALESTINE = 'State of Palestine',
  SUDAN = 'Sudan',
  SURINAME = 'Suriname',
  SVALBARD_AND_JAN_MAYEN_ISLANDS = 'Svalbard and Jan Mayen Islands',
  SWAZILAND = 'Swaziland',
  SWEDEN = 'Sweden',
  SWITZERLAND = 'Switzerland',
  SYRIAN_ARAB_REPUBLIC = 'Syrian Arab Republic',
  TAIWAN = 'Taiwan',
  TAJIKISTAN = 'Tajikistan',
  TANZANIA = 'Tanzania',
  THAILAND = 'Thailand',
  TOGO = 'Togo',
  TOKELAU = 'Tokelau',
  TONGA = 'Tonga',
  TRINIDAD_AND_TOBAGO = 'Trinidad and Tobago',
  TUNISIA = 'Tunisia',
  TURKEY = 'Turkiye',
  TURKMENISTAN = 'Turkmenistan',
  TURKS_AND_CAICOS_ISLANDS = 'Turks and Caicos Islands',
  TUVALU = 'Tuvalu',
  UGANDA = 'Uganda',
  UKRAINE = 'Ukraine',
  UNITED_ARAB_EMIRATES = 'United Arab Emirates',
  UNITED_KINGDOM = 'United Kingdom',
  UNITED_STATES = 'United States',
  URUGUAY = 'Uruguay',
  US_MINOR_OUTLYING_ISLANDS = 'US Minor Outlying Islands',
  UZBEKISTAN = 'Uzbekistan',
  VANUATU = 'Vanuatu',
  VENEZUELA = 'Venezuela',
  VIETNAM = 'Vietnam',
  VIRGIN_ISLANDS_BRITISH = 'Virgin Islands (British)',
  VIRGIN_ISLANDS_USA = 'Virgin Islands (USA)',
  WALLIS_AND_FUTUNA = 'Wallis And Futuna',
  WESTERN_SAHARA = 'Western Sahara',
  YEMEN = 'Yemen',
  ZAMBIA = 'Zambia',
  ZIMBABWE = 'Zimbabwe',
}
